import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Staff from './pages/Staff';
import { staffPortal } from './api';

function App() {
  React.useEffect(() => { window.fbdBootReady?.(); }, []);
  return (
    <div className="App">
      <StoreProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/staff" element={<StaffRedirect />} />
            <Route path="/staff/select" element={<StaffRedirect />} />
            <Route path="/staff/b2c" element={<Staff />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </StoreProvider>
    </div>
  );
}

export default App;

function StaffRedirect() {
  React.useEffect(() => { window.location.replace(staffPortal()); }, []);
  return <a href={staffPortal()}>Open staff sign in</a>;
}
